import { ComponentProps } from "react";
import AuthorDetails from "@routes/Author/components/AuthorDetails";
import { ProfileContent } from "@typings/Cue";

import { PROFILE_URI_MAPPING } from "./constants";

/**
 * Helper function to get the alternative path for the profiles.
 * @param uri The uri of the profile.
 * @returns {string|undefined}
 */
export const getProfilesAlternativePath = (
  uri?: string
): string | undefined => {
  const profileMatch = PROFILE_URI_MAPPING.find(
    (profile) => profile.uri === uri
  );

  return profileMatch?.urlPath;
};

/**
 * Helper function to check if the profile path is reserved.
 * @param urlPath The url path of the profile.
 * @returns {boolean}
 */
export const isProfilePathReserved = (urlPath: string): boolean => {
  return PROFILE_URI_MAPPING.some((profile) => profile.urlPath === urlPath);
};

/**
 * Helper function to get the author details props.
 * @param profile The profile content.
 * @returns {ComponentProps<typeof AuthorDetails>}
 */
export const getAuthorDetailsProps = ({
  headshotImage,
  fields: { name, designation, email, twitterHandle, bio_raw },
  urlPath,
}: ProfileContent): ComponentProps<typeof AuthorDetails> => {
  const headshotImageFields = headshotImage?.[0]?.content.fields;
  const originalHeadshotImage = headshotImageFields?.["original-caas"]?.url;
  const squareHeadshotImage = headshotImageFields?.["square_560-caas"]?.url;

  const authorDetailsProps = {
    headshotImage: squareHeadshotImage || originalHeadshotImage,
    name,
    designation,
    email,
    twitterHandle,
    bio_raw,
    urlPath,
  };

  return JSON.parse(JSON.stringify(authorDetailsProps));
};
